import React from 'react';
import { Upload, Icon, Card, notification } from 'antd';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import { uploadImage } from '../api';

class ImageUploader extends React.Component {
  handleImageChange = info => {
    if (info.file.status === 'error') {
      notification.error({
        message: 'Failed to upload file'
      });
    }

    if (info.file.status === 'done') {
      const {
        response: { url }
      } = info.file;
      this.props.updateFileList([...this.props.fileList, url]);
    }
  };

  removeImage = image => {
    const { fileList, updateFileList } = this.props;
    updateFileList(fileList.filter(i => i !== image));
  };

  onDragEnd = result => {
    if (!result.destination) {
      return;
    }

    const { fileList, updateFileList } = this.props;
    const list = [...fileList];
    const [removed] = list.splice(result.source.index, 1);
    list.splice(result.destination.index, 0, removed);

    updateFileList(list);
  };

  render() {
    const { action, fileList, loading } = this.props;

    return (
      <td className="editor__uploader">
        <DragDropContext onDragEnd={this.onDragEnd}>
          <Droppable droppableId="droppable-horiz" direction="horizontal">
            {(provided, snapshot) => (
              <div ref={provided.innerRef}>
                {fileList.map((image, index) => (
                  <Draggable key={index} draggableId={index} index={index}>
                    {(provided, snapshot) => (
                      <div
                        ref={provided.innerRef}
                        {...provided.draggableProps}
                        {...provided.dragHandleProps}
                        className="editor__uploader--card-container"
                      >
                        <Card
                          className="editor__uploader--card"
                          cover={<img src={image} />}
                          extra={
                            <a onClick={() => this.removeImage(image)}>
                              <Icon type="delete" theme="outlined" />
                            </a>
                          }
                        />
                      </div>
                    )}
                  </Draggable>
                ))}
                {provided.placeholder}
              </div>
            )}
          </Droppable>
        </DragDropContext>
        <Upload
          accept="image/*"
          action={action}
          listType="picture-card"
          onChange={this.handleImageChange}
          disabled={loading}
          showUploadList={false}
        >
          <div>
            <Icon type="plus" />
            <div className="ant-upload-text">Upload</div>
          </div>
        </Upload>
      </td>
    );
  }
}

export default ImageUploader;
